import { render, staticRenderFns } from "./mc-receive.tests.vue?vue&type=template&id=f52aeac4&scoped=true"
import script from "./mc-receive.tests.vue?vue&type=script&lang=ts"
export * from "./mc-receive.tests.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f52aeac4",
  null
  
)

export default component.exports